import { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import { DEFAULT_PAGE } from '../constants';

export type SupportedPages = 'dashboard' | 'selection' | 'connect';

const useActivePage = (): { activePage: SupportedPages } => {
  const { pathname } = useLocation();
  const [activePage, setActivePage] = useState<SupportedPages>('connect');
  const [, moduleName] = pathname.split('/');
  useEffect(() => {
    const pathModuleMap: { [key: string]: SupportedPages } = {
      'dashboard': 'dashboard',
      'account-selection': 'selection',
    };

    setActivePage(pathModuleMap[moduleName] || DEFAULT_PAGE);
  }, [pathname]);

  return { activePage };
};

export default useActivePage;
